import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { Button } from '@mm/components';
import { useChatbotCRUDActions } from '@mm/state/actions/ChatbotCRUDActions';
import { chatWidgetTroubleshootingLastResultSelector } from '@mm/state/selectors/chatWidgetTroubleshootingSelectors';
import {
  activeChatbotIdSelector,
  activeFacebookPageIdSelector,
} from '@mm/state/selectors/viewSelectors';
import {
  ChatWidgetTroubleshootingToolResultTypes,
  Result,
} from '../ChatWidgetTroubleshootingToolResult';

type Props = {
  runDiagnostic: () => Promise<void>;
};
export const useChatbotActiveResult = (props: Props): Result => {
  const { runDiagnostic } = props;
  const result = useSelector(chatWidgetTroubleshootingLastResultSelector);
  const botId = useSelector(activeChatbotIdSelector);
  const facebookPageId = useSelector(activeFacebookPageIdSelector);
  const [activating, setActivating] = useState(false);

  const chatbotCRUDActions = useChatbotCRUDActions();
  const activateChatbot = async () => {
    setActivating(true);
    await chatbotCRUDActions.attachToFacebookPage(botId, facebookPageId);
    await runDiagnostic();
    setActivating(false);
  };

  if (!result) {
    return;
  }

  if (result.localTests.botActive) {
    return {
      type: ChatWidgetTroubleshootingToolResultTypes.ChatbotActiveResult,
      result: 'ok',
      description: 'Chatbot is active',
    };
  }
  return {
    type: ChatWidgetTroubleshootingToolResultTypes.ChatbotActiveResult,
    result: 'error',
    description: (
      <>
        Chatbot is not active
        <Button onClick={activateChatbot} disabled={activating}>
          Activate Chatbot
        </Button>
      </>
    ),
  };
};
